import { alpha, Components, Theme as MuiTheme } from '@mui/material';

export const dialogTheme: Components<MuiTheme> = {
  MuiDialog: {
    styleOverrides: {
      root: ({ theme }) => ({
        '& .MuiBackdrop-root': {
          backgroundColor: alpha(theme.palette.text.main, 0.4),
        },
      }),
      paper: ({ theme }) => ({
        backgroundColor: theme.palette.background.default,
        borderRadius: theme.customShape.borderRadius5XL,
        margin: theme.spacing(4),
      }),
    },
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: ({ theme }) => ({
        backgroundColor: 'transparent',
        color: theme.palette.text.primary,
        paddingBottom: theme.spacing(2),
        marginBottom: theme.spacing(2),
      }),
    },
  },
  MuiDialogContent: {
    styleOverrides: {
      root: ({ theme }) => ({
        backgroundColor: 'transparent',
        color: theme.palette.text.primary,
      }),
    },
  },
  MuiDialogActions: {
    styleOverrides: {
      root: ({ theme }) => ({
        backgroundColor: 'transparent',
        borderTop: `1px solid ${theme.palette.info.main}`,
        paddingTop: theme.spacing(2),
        marginTop: theme.spacing(2),
      }),
    },
  },
};
